import { getFunctions, httpsCallable } from 'firebase/functions';
import { firebaseApp } from '../firebase';

const functions = getFunctions(firebaseApp, 'europe-west1');

type SubmitDiscussionPollResponseInput = {
  topicId: string;
  answers: Record<string, string>;
};

type EditDiscussionTopicInput = {
  topicId: string;
  title: string;
  body: string;
  authorDisplayName?: string;
};

type ReportDiscussionContentInput =
  | {
      targetType: 'topic';
      topicId: string;
    }
  | {
      targetType: 'reply';
      topicId: string;
      replyId: string;
    };

type CreateDiscussionAttachmentOpenUrlInput =
  | {
      kind: 'topic';
      topicId: string;
      attachmentId: string;
    }
  | {
      kind: 'reply';
      topicId: string;
      replyId: string;
      attachmentId: string;
    };

export async function submitDiscussionPollResponse(input: SubmitDiscussionPollResponseInput) {
  const callable = httpsCallable<SubmitDiscussionPollResponseInput, { ok: boolean }>(
    functions,
    'submitDiscussionPollResponse'
  );
  await callable(input);
}

export async function editDiscussionTopic(input: EditDiscussionTopicInput) {
  const callable = httpsCallable<EditDiscussionTopicInput, { ok: boolean; changed: boolean }>(
    functions,
    'editDiscussionTopic'
  );
  const result = await callable(input);
  return result.data;
}

export async function reportDiscussionContent(input: ReportDiscussionContentInput) {
  const callable = httpsCallable<ReportDiscussionContentInput, { ok: boolean }>(
    functions,
    'reportDiscussionContent'
  );
  const result = await callable(input);
  return result.data;
}

export async function createDiscussionAttachmentOpenUrl(input: CreateDiscussionAttachmentOpenUrlInput) {
  const callable = httpsCallable<CreateDiscussionAttachmentOpenUrlInput, { url: string }>(
    functions,
    'createDiscussionAttachmentOpenUrl'
  );
  const result = await callable(input);
  return result.data.url;
}
